export default __webpack_public_path__ + "static/media/logo_app.723550ac.png";